import {
  PublicClientApplication,
  LogLevel,
  Configuration,
} from '@azure/msal-browser';
import { environment } from '../environments/environments';

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
};

const msalConfig: Configuration = {
  auth: {
    clientId: environment.root.clientId,
    authority: `https://login.microsoftonline.com/${environment.root.tenantId}`,
    redirectUri: environment.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
  await msalInstance.initialize();
}
